import { render, staticRenderFns } from "./editProfile.vue?vue&type=template&id=38b89bac&scoped=true"
import script from "./editProfile.vue?vue&type=script&lang=js"
export * from "./editProfile.vue?vue&type=script&lang=js"
import style0 from "./editProfile.vue?vue&type=style&index=0&id=38b89bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b89bac",
  null
  
)

export default component.exports